import { createSlice } from "@reduxjs/toolkit";

import {
  addBusinessAddressAction,
  addCustomerSupplierAction,
  addStockItemAction,
  addUnitMeasurementListAction,
  addStockGrouopAction,
  checkUniqueLegalCustomerSupplierAction,
  editBusinessAddressAction,
  editCustomerSupplierAction,
  getAllBusinessAddressAction,
  getAllCustomerSupplierAction,
  getAllExpensesLedgersListAction,
  getAllIncomeLedgersListAction,
  getAllTypesLedgerListAction,
  getAllTypesParentStockGroupAction,
  getAllTypesStocksGroupAction,
  getAllTypesWithTaxListAction,
  getAllUnitMeasurementListAction,
  getSingleTypeLedgerListAction,
  updateStockGroupAction,
  updateUnitsMeasermentAction,
  getAllStockItemListAction,
  updateStockItemAction,
  checkUniqueSkuNumberAction,
  getSingleCustomerSupplierAction,
  getDepartmentListAction,
  createDepartmentAction,
  updateDepartmentAction,
  checkUniqueDepartmentNameAction,
  getSingleBusinessAddressAction,
  getSingleStockItemDataAction,
  getMultipleStockItemQuantityAction,
  changeCustomerSupplierStatusAction,
  getMappedPdfTemplateAction,
  createMappedPdfTemplateAction,
  multipleUploadFilesAction,
  stockItemBulkUploadDataAction,
  addTurnOverHSNCheckAction,
  updateTurnOverHSNCheckAction,
  getHsnCheckAction,
  addHsnCheckWarningAction,
  customerSupplierBulkUploadDataAction,
  addBatchManagementAction,
  updateBatchManagementAction,
  getBatchManagementAction,
  getSingleBatchManagementAction,
  changeBatchStatusAction,
  checkUniqueBatchNumberAction,
  addAutoUniqueNumberGenerationAction,
  getAutoUniqueNumberGenerationAction,
  getStockMappedBatchListAction,
  getCustomerSupplierGroupingListAction,
  addLedgerAction,
  checkUniqueLedgerAction,
  getAllLedgersListAction,
  updateLedgerAction,
  getDocumentTypeListingAction,
  addDocumentTypeAliasNameAction,
  checkUniqueGstNumberAction,
} from "@/redux/clientSettings/actions";
import type { ClientSettingsType } from "@/redux/clientSettings/clientSettingTypes";
import { initialState } from "@/redux/clientSettings/initialState";
import { clientSettingsReducer } from "@/redux/clientSettings/reducer";

export const clientSettingsSlice = createSlice({
  name: "clientSettings",
  initialState,
  reducers: clientSettingsReducer,

  extraReducers: (builder) => {
    builder.addCase(
      addBusinessAddressAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addBusinessAddressAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      addBusinessAddressAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      editBusinessAddressAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      editBusinessAddressAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      editBusinessAddressAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllBusinessAddressAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllBusinessAddressAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          businessAddressList: result,
        };
      }
    );

    builder.addCase(
      getAllBusinessAddressAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getSingleBusinessAddressAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleBusinessAddressAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleBusinessAddressList: result,
        };
      }
    );

    builder.addCase(
      getSingleBusinessAddressAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addCustomerSupplierAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addCustomerSupplierAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          customerSupplierMessage: message,
        };
      }
    );

    builder.addCase(
      addCustomerSupplierAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      changeCustomerSupplierStatusAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      changeCustomerSupplierStatusAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      changeCustomerSupplierStatusAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      editCustomerSupplierAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      editCustomerSupplierAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          customerSupplierMessage: message,
        };
      }
    );

    builder.addCase(
      editCustomerSupplierAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllCustomerSupplierAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllCustomerSupplierAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          customerSupplierList: result,
          customerSupplierListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllCustomerSupplierAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getSingleCustomerSupplierAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
        singleCustomerSupplierFetching: true,
      })
    );

    builder.addCase(
      getSingleCustomerSupplierAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            singleCustomerSupplierFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          singleCustomerSupplierFetching: false,
          statusCode: status_code,
          singleCustomerSupplier: result,
        };
      }
    );

    builder.addCase(
      getSingleCustomerSupplierAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        singleCustomerSupplierFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addLedgerAction.pending, (state: ClientSettingsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addLedgerAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addLedgerAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueLedgerAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        uniqueLedgerFetching: true,
        ledgerMessage: null,
      })
    );

    builder.addCase(
      checkUniqueLedgerAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            uniqueLedgerFetching: false,
            ledgerMessage: null,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          uniqueLedgerFetching: false,
          ledgerMessage: message,
        };
      }
    );

    builder.addCase(
      checkUniqueLedgerAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        uniqueLedgerFetching: false,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllLedgersListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllLedgersListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        let finalData: any = [];

        // Manipulating Data
        result &&
          result?.length > 0 &&
          result?.map((tempData: any) => {
            if (tempData?.to_show) {
              finalData.push({
                ...tempData,
              });
            }
            if (tempData?.is_tree) {
              tempData?.tree_data?.map((tree: any) => {
                if (tree?.to_show) {
                  finalData.push({
                    ...tree,
                  });
                }
                if (tree?.is_tree) {
                  tree?.tree_data?.map((treeD: any) => {
                    if (treeD?.to_show) {
                      finalData.push({
                        ...treeD,
                      });
                    }
                    if (treeD?.is_tree) {
                      treeD?.tree_data?.map((treeD1: any) => {
                        if (treeD1?.to_show) {
                          finalData.push({
                            ...treeD1,
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });

        return {
          ...state,
          fetching: false,
          allLedgersList: result,
          allShowLedgersList: finalData,
          statusCode: status_code,
          allLedgersListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllLedgersListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllExpensesLedgersListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllExpensesLedgersListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          allExpensesLedgersList: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getAllExpensesLedgersListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllIncomeLedgersListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllIncomeLedgersListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          allIncomeLedgersList: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getAllIncomeLedgersListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateLedgerAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateLedgerAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      updateLedgerAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllTypesLedgerListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllTypesLedgerListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, message, result, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        let finalData =
          result &&
          result?.length > 0 &&
          result?.filter((data: any) => data?.to_show);

        return {
          ...state,
          fetching: false,
          allTypesLedgersList: finalData,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getAllTypesLedgerListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getAllTypesWithTaxListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllTypesWithTaxListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, message, result, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        let finalData =
          result &&
          result?.length > 0 &&
          result?.filter((data: any) => data?.to_show);
        return {
          ...state,
          fetching: false,
          allTypesLedgersWithTaxList: finalData,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getAllTypesWithTaxListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      checkUniqueLegalCustomerSupplierAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        uniqueLegalNameFetching: true,
      })
    );

    builder.addCase(
      checkUniqueLegalCustomerSupplierAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, message, result, success } = payload;
        if (success === 0) {
          return {
            ...state,
            uniqueLegalNameFetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          uniqueLegalNameFetching: false,
          uniqueLegalNameMessage: message,
        };
      }
    );

    builder.addCase(
      getSingleTypeLedgerListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleTypeLedgerListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          singleTypeLedgerList: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getSingleTypeLedgerListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllTypesStocksGroupAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllTypesStocksGroupAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          groupStockList: result,
          statusCode: status_code,
          groupStockListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllTypesStocksGroupAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      addUnitMeasurementListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addUnitMeasurementListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      addUnitMeasurementListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateUnitsMeasermentAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateUnitsMeasermentAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateUnitsMeasermentAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addStockItemAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addStockItemAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      addStockItemAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateStockItemAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateStockItemAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateStockItemAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllStockItemListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllStockItemListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          allStockItemList: result.data,
          stockItemListTotal: result.total_count,
        };
      }
    );

    builder.addCase(
      getAllStockItemListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      checkUniqueSkuNumberAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        uniqueSkuFetching: true,
        skuMessage: null,
      })
    );

    builder.addCase(
      checkUniqueSkuNumberAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            uniqueSkuFetching: false,
            skuMessage: null,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          uniqueSkuFetching: false,
          skuMessage: message,
        };
      }
    );

    builder.addCase(
      checkUniqueSkuNumberAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        uniqueSkuFetching: false,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllUnitMeasurementListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllUnitMeasurementListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          allUnitsMeasurement: result.data,
          unitsMeasurementListTotal: result.total_count,
        };
      }
    );

    builder.addCase(
      getAllUnitMeasurementListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllTypesParentStockGroupAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllTypesParentStockGroupAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          groupParentStockList: result,
          statusCode: status_code,
          groupStockListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllTypesParentStockGroupAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      addStockGrouopAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addStockGrouopAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      addStockGrouopAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateStockGroupAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateStockGroupAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateStockGroupAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getSingleStockItemDataAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleStockItemDataAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleStockItemData: result,
        };
      }
    );

    builder.addCase(
      getSingleStockItemDataAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getDepartmentListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getDepartmentListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          departmentList: result.data,
          departmentTotalCount: result.total_count,
        };
      }
    );

    builder.addCase(
      getDepartmentListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMultipleStockItemQuantityAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMultipleStockItemQuantityAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          multipleStockItemQuantityData: result,
        };
      }
    );

    builder.addCase(
      getMultipleStockItemQuantityAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      createDepartmentAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createDepartmentAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createDepartmentAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateDepartmentAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateDepartmentAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      updateDepartmentAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueDepartmentNameAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        departmentUniqueCheckFetching: true,
      })
    );

    builder.addCase(
      checkUniqueDepartmentNameAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload?.data;

        if (success === 0) {
          return {
            ...state,
            success: success,
            departmentUniqueCheckFetching: false,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          departmentUniqueCheckFetching: false,
          departmentUniqueCheckMessage: message,
          statusCode: status_code,
          success: success,
        };
      }
    );

    builder.addCase(
      checkUniqueDepartmentNameAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        departmentUniqueCheckFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getMappedPdfTemplateAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMappedPdfTemplateAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          mappedPdfTemplate: result?.data,
        };
      }
    );

    builder.addCase(
      getMappedPdfTemplateAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      createMappedPdfTemplateAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMappedPdfTemplateAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMappedPdfTemplateAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      multipleUploadFilesAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        multipleFileUploadFetching: true,
      })
    );

    builder.addCase(
      multipleUploadFilesAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code, stockFileUploadSuccess } =
          payload;

        if (success === 0) {
          return {
            ...state,
            multipleFileUploadFetching: false,
            multipleFileUploadError: message,
            statusCode: status_code,
            multipleFileUploadSuccess: success,
          };
        }

        return {
          ...state,
          multipleFileUploadFetching: false,
          statusCode: status_code,
          multipleFileUploadData: payload.files,
          multipleFileUploadSuccess: success,
        };
      }
    );

    builder.addCase(
      multipleUploadFilesAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        multipleFileUploadFetching: false,
        multipleFileUploadError: error?.message ?? null,
        multipleFileUploadSuccess: 0,
      })
    );

    builder.addCase(
      stockItemBulkUploadDataAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      stockItemBulkUploadDataAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, data = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          stockItemBulkUploadData: payload,
        };
      }
    );

    builder.addCase(
      stockItemBulkUploadDataAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addTurnOverHSNCheckAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addTurnOverHSNCheckAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addTurnOverHSNCheckAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateTurnOverHSNCheckAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateTurnOverHSNCheckAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateTurnOverHSNCheckAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getHsnCheckAction.pending, (state: ClientSettingsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getHsnCheckAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          clientMappedHSNData: result,
        };
      }
    );

    builder.addCase(
      getHsnCheckAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      addHsnCheckWarningAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addHsnCheckWarningAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            warningSuccess: success,
            warningError: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          warningSuccess: success,
          warningMessage: message,
        };
      }
    );

    builder.addCase(
      addHsnCheckWarningAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        warningSuccess: 0,
        warningError: error?.message ?? null,
      })
    );

    builder.addCase(
      customerSupplierBulkUploadDataAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      customerSupplierBulkUploadDataAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, data = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          customerSupplierBulkUploadData: payload,
        };
      }
    );

    builder.addCase(
      customerSupplierBulkUploadDataAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addBatchManagementAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addBatchManagementAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success: success,
          message: message,
        };
      }
    );

    builder.addCase(
      addBatchManagementAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateBatchManagementAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateBatchManagementAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateBatchManagementAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getBatchManagementAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getBatchManagementAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          batchManagementList: result,
          batchManagementListTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getBatchManagementAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getSingleBatchManagementAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleBatchManagementAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singlebatchDetailsData: result,
        };
      }
    );

    builder.addCase(
      getSingleBatchManagementAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      changeBatchStatusAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      changeBatchStatusAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      changeBatchStatusAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      checkUniqueBatchNumberAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        batchNumberFetching: true,
        batchNumberUniqueMessage: null,
      })
    );

    builder.addCase(
      checkUniqueBatchNumberAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            batchNumberFetching: false,
            batchNumberUniqueMessage: null,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          batchNumberFetching: false,
          batchNumberUniqueMessage: message,
        };
      }
    );

    builder.addCase(
      checkUniqueBatchNumberAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        batchNumberFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addAutoUniqueNumberGenerationAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addAutoUniqueNumberGenerationAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addAutoUniqueNumberGenerationAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAutoUniqueNumberGenerationAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAutoUniqueNumberGenerationAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        if (result?.general_settings_type === "alternate_quantity_settings") {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            alternateQuantitySettingsData: result,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          autoUniqueNumberGenerationData: result,
        };
      }
    );

    builder.addCase(
      getAutoUniqueNumberGenerationAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getStockMappedBatchListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getStockMappedBatchListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          mappedStockBatchList: result,
          mappedStockBatchListTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getStockMappedBatchListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getCustomerSupplierGroupingListAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getCustomerSupplierGroupingListAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          customerSupplierGroupingList: result,
          customerSupplierGroupingTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getCustomerSupplierGroupingListAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
    ////document type alias

    builder.addCase(
      getDocumentTypeListingAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getDocumentTypeListingAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          documentTypeListing: result,
        };
      }
    );

    builder.addCase(
      getDocumentTypeListingAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      addDocumentTypeAliasNameAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addDocumentTypeAliasNameAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addDocumentTypeAliasNameAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    // unique gst number

    builder.addCase(
      checkUniqueGstNumberAction.pending,
      (state: ClientSettingsType) => ({
        ...state,
        uniqueGstNumberFetching: true,
        uniqueGstNumberMessage: null,
      })
    );

    builder.addCase(
      checkUniqueGstNumberAction.fulfilled,
      (state: ClientSettingsType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            uniqueGstNumberFetching: false,
            uniqueGstNumberMessage: null,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          uniqueGstNumberFetching: false,
          uniqueGstNumberMessage: message,
        };
      }
    );

    builder.addCase(
      checkUniqueGstNumberAction.rejected,
      (state: ClientSettingsType, { error }) => ({
        ...state,
        uniqueGstNumberFetching: false,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetClientSettingsError,
  resetClientSettingsFetching,
  resetClientSettingsStatusCode,
  resetClientSettingsSuccess,
  resetBusinessAddressList,
  resetCustomerSupplierList,
  resetLedgerMessage,
  resetAllLedgersList,
  resetAllExpensesLedgersList,
  resetAllIncomeLedgersList,
  resetSingleTypeLedgersList,
  resetLegalNameMessage,
  resetStockGroupList,
  resetAllUnitsMeasurmentList,
  resetStockItemList,
  resetSingleCustomerSupplier,
  resetCustomerSupplierMessage,
  resetStockGroupsListTotal,
  resetStockGroupActionList,
  resetCustomerSupplierListTotal,
  resetAllLedgersListTotal,
  resetStockItemListTotal,
  resetUnitsMeasurementListTotal,
  resetDepartmentTotalCount,
  resetDepartmentList,
  resetDepartmentMessage,
  resetDepartmentUniqueCheckFetching,
  resetDepartmentUniqueCheckMessage,
  resetSingleBusinessAddressList,
  resetSingleStockItemData,
  resetMultipleStockItemQuantityData,
  resetAllTypesLedgerListWithTaxList,
  resetMessage,
  resetMappedPdfTemplate,
  resetMultipleFileUploadFetching,
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetMultipleFileUploadSuccess,
  resetStockItemBulkUpload,
  resetClientMappedHSNData,
  resetCustomerSupplierBulkUploadData,
  resetBatchManagementList,
  resetSinglebatchDetailsData,
  resetBatchNumberUniqueMessage,
  resetBatchManagementListTotalCount,
  resetAutoUniqueNumberGenerationData,
  resetAlternateQuantitySettingsData,
  resetMappedStockBatchList,
  resetMappedStockBatchListTotalCount,
  resetCustomerSupplierGroupingList,
  resetCustomerSupplierGroupingTotalCount,
  resetUniqueGstNumberFetching,
  resetUniqueGstNumberMessage,
} = clientSettingsSlice.actions;
